import { getListIdForFilters } from '../helper';

export const practicePracticeEfectorVisitsActions = {

  FETCH_PRACTICE_EFECTOR_VISITS_FAILED: 'FETCH_PRACTICE_EFECTOR_VISITS_FAILED',
  FETCH_PRACTICE_EFECTOR_VISITS_SUCCESS: 'FETCH_PRACTICE_EFECTOR_VISITS_SUCCESS',
  FETCH_PRACTICE_EFECTOR_VISITS_PENDING: 'FETCH_PRACTICE_EFECTOR_VISITS_PENDING',
  LOAD_PRACTICE_EFECTOR_VISITS: 'LOAD_PRACTICE_EFECTOR_VISITS',

  fetchPracticeEfectorVisitsFailed: (error, practicePracticeEfectorVisitsId) => ({
    type: practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_FAILED,
    payload: {
      error,
      practicePracticeEfectorVisitsId
    }
  }),

  fetchPracticeEfectorVisitsSuccess: (practicePracticeEfectorVisitsId, {data}) => ({
    type: practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_SUCCESS,
    payload: {
      data,
      practicePracticeEfectorVisitsId
    }
  }),

  fetchPracticeEfectorVisitsPending: practicePracticeEfectorVisitsId => ({
    type: practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_PENDING,
    payload: {
      practicePracticeEfectorVisitsId
    }
  }),

  loadPracticeEfectorVisits: filters => {
    let new_filters = filters.toJS()
    return ({
      type: practicePracticeEfectorVisitsActions.LOAD_PRACTICE_EFECTOR_VISITS,
      payload: {
        practicePracticeEfectorVisitsId: '_pevs_'+getListIdForFilters(new_filters),
        filters: new_filters,
      }
    })
  },

};


export const practicePracticeEfectorVisitsRequestActions = {
  failed: practicePracticeEfectorVisitsActions.fetchPracticeEfectorVisitsFailed,
  success: practicePracticeEfectorVisitsActions.fetchPracticeEfectorVisitsSuccess,
  pending: practicePracticeEfectorVisitsActions.fetchPracticeEfectorVisitsPending
};
